import { createSelector } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';
import { getRooms } from './rooms';
import { getAllOffers } from '../../utils/offersUtils';
import { getHotelId } from '../hotel';
import { getRoomsOperators } from './common';

export const getOffers = createSelector(
  [getRooms, getHotelId],
  (rooms, hotelId) => (isEmpty(rooms) ? [] : getAllOffers(rooms, hotelId)),
);

export const getAnalyticsOperators = createSelector(
  [getRoomsOperators],
  (operators) => operators.map(({ id }) => id).join('|'),
);
